import { render, staticRenderFns } from "./WecomPolicyDialog.vue?vue&type=template&id=0c96778a&scoped=true"
import script from "./WecomPolicyDialog.vue?vue&type=script&lang=js"
export * from "./WecomPolicyDialog.vue?vue&type=script&lang=js"
import style0 from "./WecomPolicyDialog.vue?vue&type=style&index=0&id=0c96778a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96778a",
  null
  
)

export default component.exports